import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/lynkmandistockreport';

const lynkmandistockreport = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">REPORTS - Lynk Mandi Stock  </h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

lynkmandistockreport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(lynkmandistockreport);
